import { css } from 'emotion';

export const wrapperStyle = (inline, width, justify, center) => {
	if (!inline) {
		return css({
			'& a': {
				display: 'block',
				margin: '20px 0',
				'& img': {
					display: 'block',
					margin: '0 auto',
					backfaceVisibility: 'hidden',
				},
				'&:first-child': {
					marginTop: '0',
				},
			},
		});
	}
	if (!justify) {
		return css({
			display: 'table',
			...(center
				? {
						margin: '0 auto',
				  }
				: null),
			'& a': {
				display: 'table-cell',
				verticalAlign: 'middle',
				padding: `0 ${width / 3}px`,
				'& img': {
					display: 'block',
					margin: '0 auto',
					backfaceVisibility: 'hidden',
				},
				'&:first-child': {
					paddingLeft: '0',
				},
				'&:last-child': {
					paddingRight: '0',
				},
			},
		});
	}
	return css({
		display: 'flex',
		justifyContent: 'space-between',
		'& a': {
			'& img': {
				backfaceVisibility: 'hidden',
			},
		},
	});
};



// WEBPACK FOOTER //
// ./src/components/shared/socialIcons/styles.js